import { render, staticRenderFns } from "./EodbOutageDashboard.vue?vue&type=template&id=366e2d83&scoped=true&"
import script from "./EodbOutageDashboard.vue?vue&type=script&lang=js&"
export * from "./EodbOutageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EodbOutageDashboard.vue?vue&type=style&index=0&id=366e2d83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e2d83",
  null
  
)

export default component.exports